/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.FileSystem')
    .factory('FileSize', function(){
        var UNITS = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];

        return {
            units: UNITS,
            bytes: function(inputValue, inputUnit) {
               if(inputValue === 0) {
                   return 0;
               }
               else if (isNaN(parseFloat(inputValue)) || !isFinite(inputValue)) {
                   return;
               } else {
                   return inputValue * (Math.pow(1024, Math.max(0, UNITS.indexOf(inputUnit))));
               }
            }
        }
    });
